import { Body1 } from '@myphx-engineering/phx-design-system';

import { useMedicationConfigOverride } from '../../../../contexts/DrugProgramProvider';
import {
    CoverageStatus,
    type DigitallyReceivedPrescriberOrderInfoFragment,
    type MailOrderProviderInfoFragment,
    type PharmacyProviderInfoFragment,
    type PrescriberInfoFragment,
    type UnknownProviderInfoFragment,
} from '../../../../graphql/generated/graphql';
import type { PharmacyOverride } from '../../../../hooks/use-config-api';

import { PriorAuthNextSteps } from './PriorAuthNextSteps';

export type ProviderNextStepsProps = {
    prescriber: PrescriberInfoFragment;
    prescriberOrder: DigitallyReceivedPrescriberOrderInfoFragment;
    provider:
        | MailOrderProviderInfoFragment
        | PharmacyProviderInfoFragment
        | UnknownProviderInfoFragment;
};

export const ProviderNextSteps = ({
    prescriber,
    prescriberOrder,
    provider,
}: ProviderNextStepsProps) => {
    const configOverride = useMedicationConfigOverride();

    const providerOverrides: PharmacyOverride | undefined =
        configOverride.pharmacyOverrides[provider.id];

    const prescriberPhone = prescriber?.phoneNumber;

    if (
        prescriberOrder.coverageInfo?.coverageStatus ===
        CoverageStatus.PriorAuthRequired
    ) {
        return <PriorAuthNextSteps prescriberPhone={prescriberPhone} />;
    }

    return <Body1>{providerOverrides?.nextStepsDescription}</Body1>;
};
